import React from "react";
import { CustomButtonVariant } from "../../../components/CustomButton/CustomButton";
import ScheduleDetailsModal from "../../../components/ScheduleDetailsModal/ScheduleDetailsModal";
import { RiverModalData } from "../models/RiverModalData";

interface ModalRiverConfirmationProps {
  isOpen: boolean;
  data: RiverModalData;
  handleClose: (open: boolean) => void;
  buttons?: Array<{
    title: string;
    onClick?: () => void;
    variant: CustomButtonVariant;
  }>;
}

const ModalRiverConfirmation: React.FC<ModalRiverConfirmationProps> = ({
  isOpen,
  data,
  handleClose,
  buttons,
}) => {
  const header = [
    {
      label: "Razão social",
      value: data.issuingCustomer?.value ?? "-",
      flex: 1,
    },
    { label: "Filial", value: data.subsidiaryDescription?.value ?? "-" },
    { label: "Data do pedido", value: data.requestDate?.value ?? "-" },
    { label: "Solicitado por:", value: data.requestUser?.value ?? "-" },
  ];

  const highlightCards = [
    {
      items: [
        { label: "Transportadora", value: data.shippingCompany?.value ?? "-" },
      ],
    },
    {
      items: [{ label: "Recebedor", value: data.receiver?.value ?? "-" }],
    },
  ];

  const details = [
    { label: "Produto", value: data.productName?.value ?? "-" },
    { label: "Modalidade", value: data.modality?.value ?? "-" },
    { label: "Quantidade", value: data.quantity?.value ?? "-" },
    {
      label: "Condição de pagamento",
      value: data.paymentCondition?.value ?? "-",
    },
  ];

  const footer = {
    label: "Observação",
    value: data.requestNote?.value ?? "-",
  };

  const actions = buttons?.map((btn) => ({
    label: btn.title,
    variant: btn.variant,
    onClick: btn.onClick,
  }));

  return (
    <ScheduleDetailsModal
      open={isOpen}
      onClose={() => handleClose(false)}
      title="Detalhes do pedido de agendamento"
      header={header}
      highlightCards={highlightCards}
      details={details}
      footer={footer}
      actions={actions}
    />
  );
};

export default ModalRiverConfirmation;
